import React, { useState } from 'react';

const Simulation = () => {
  const [tableData, setTableData] = useState([]);
  const [output, setOutput] = useState('');
  const [simulationStarted, setSimulationStarted] = useState(false);

  const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

  const startSimulation = async () => {
    setSimulationStarted(true);

    let batt1 = 100;
    let batt2 = 100;
    let simulationOutput = '';
    let tempTableData = [];

    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    for (let time = 1; time <= 24; time++) {
      let pvgen1, pvgen2, load1, load2;

      if (time >= 6 && time < 15) {
        pvgen1 = Math.floor(Math.random() * (300 - 150 + 1)) + 150;
        pvgen2 = Math.floor(Math.random() * (300 - 150 + 1)) + 150;
        load1 = Math.floor(Math.random() * (400 - 300 + 1)) + 300;
        load2 = Math.floor(Math.random() * (400 - 300 + 1)) + 300;
      } else if (time >= 15 && time < 22) {
        pvgen1 = Math.floor(Math.random() * (300 - 150 + 1)) + 150;
        pvgen2 = Math.floor(Math.random() * (300 - 150 + 1)) + 150;
        load1 = Math.floor(Math.random() * (500 - 400 + 1)) + 400;
        load2 = Math.floor(Math.random() * (500 - 400 + 1)) + 400;
      } else if (time >= 22 || time < 6) {
        pvgen1 = Math.floor(Math.random() * (300 - 150 + 1)) + 150;
        pvgen2 = Math.floor(Math.random() * (300 - 150 + 1)) + 150;
        load1 = Math.floor(Math.random() * (300 - 250 + 1)) + 250;
        load2 = Math.floor(Math.random() * (300 - 250 + 1)) + 250;
      }

      tempTableData.push({ time, pvgen1, pvgen2, load1, load2 });

      setTableData([...tempTableData]);

      await sleep(100);

      simulationOutput += `Hour: ${time}\n`;
      simulationOutput += `pvgen1: ${pvgen1}\n`;
      simulationOutput += `pvgen2: ${pvgen2}\n`;
      simulationOutput += `load1: ${load1}\n`;
      simulationOutput += `load2: ${load2}\n`;

      if (load1 < batt1 + pvgen1 && load2 > batt2 + pvgen2 && batt1 + pvgen1 - load1 - (load2 - (batt2 + pvgen2)) >= 0) {
        simulationOutput += 'It is Case1: M1 surplus M2 Deficit and M1 surplus is enough\n';
        simulationOutput += 'Battery2, pvgen2 will completely get diminished and there is a need for energy taken from M1\n';
        simulationOutput += 'M1 surplus energy is enough alone, no need for energy from Generation\n';

        if (pvgen1 >= load1) {
          simulationOutput += 'Battery1 doesn\'t get discharged since pvgen1 alone is enough to clear load1\n';

          if (pvgen1 - load1 >= load2 - pvgen2 - batt2) {
            simulationOutput += 'M2 is cleared since pvgen1 alone is sufficient; battery1 is not needed to discharge\n';

            if (batt1 < 100) {
              if (pvgen1 - load1 - (load2 - pvgen2 - batt2) > 100 - batt1) {
                simulationOutput += 'Excess Energy is getting stored in battery after clearing M2\n';
                batt1 = 100;
              } else {
                simulationOutput += 'Excess Energy is getting stored in battery after clearing M2\n';
                batt1 += pvgen1 - load1 - (load2 - batt2 - pvgen2);
              }
            } else {
              simulationOutput += 'Excess Energy is getting stored in battery after clearing M2\n';
              batt1 += pvgen1 - load1 - (load2 - batt2 - pvgen2);
            }
          } else {
            simulationOutput += 'Whole Pvgen1 is used to provide energy to M2 and the rest is taken from the battery\n';
            batt1 -= (load2 - pvgen2 - batt2) - (pvgen1 - load1);
          }
        } else {
          simulationOutput += 'Battery 1 is used to clear the load1, and the rest is given to M2\n';
          batt1 -= (load1 - pvgen1) + (load2 - pvgen2 - batt2);
        }
        batt2 = 0;
      } else if (load1 < batt1 + pvgen1 && load2 > batt2 + pvgen2 && batt1 + pvgen1 - load1 - (load2 - (batt2 + pvgen2)) < 0) {
        simulationOutput += 'It is Case2: M1 surplus M2 Deficit but M1 surplus is not enough, G is needed\n';
        simulationOutput += 'Battery2, pvgen2 will completely get diminished, and there is a need for energy taken from M1\n';
        simulationOutput += 'M1 surplus energy is not enough, and energy from Generation is needed\n';
        simulationOutput += 'Both batteries get discharged completely\n';
        batt1 = 0;
        batt2 = 0;
      } else if (load2 < batt2 + pvgen2 && load1 > batt1 + pvgen1 && batt2 + pvgen2 - load2 - (load1 - (batt1 + pvgen1)) >= 0) {
        simulationOutput += 'It is Case3: M2 surplus M1 Deficit and M2 surplus is enough\n';
        simulationOutput += 'Battery1, pvgen1 will completely get diminished, and there is a need for energy taken from M2\n';
        simulationOutput += 'M2 surplus energy is enough alone, no need for energy from Generation\n';

        if (pvgen2 >= load2) {
          simulationOutput += 'Battery2 doesn\'t get discharged since pvgen1 alone is enough to clear load2\n';

          if (pvgen2 - load2 >= load1 - pvgen1 - batt1) {
            simulationOutput += 'M1 is cleared since pvgen1 alone is sufficient; battery1 is not needed to discharge\n';

            if (batt2 < 100) {
              if (pvgen2 - load2 - (load1 - pvgen1 - batt1) > 100 - batt2) {
                simulationOutput += 'Excess Energy is getting stored in battery after clearing M1\n';
                batt2 = 100;
              } else {
                simulationOutput += 'Excess Energy is getting stored in battery after clearing M1\n';
                batt2 += pvgen2 - load2 - (load1 - batt1 - pvgen1);
              }
            } else {
              simulationOutput += 'Excess Energy is getting stored in battery after clearing M1\n';
              batt2 += pvgen2 - load2 - (load1 - batt1 - pvgen1);
            }
          } else {
            simulationOutput += 'Whole Pvgen2 is used to provide energy to M1 and the rest is taken from the battery\n';
            batt2 -= (load1 - pvgen1 - batt1) - (pvgen2 - load2);
          }
        } else {
          simulationOutput += 'Battery 2 is used to clear the load2, and the rest is given to M1\n';
          batt2 -= (load2 - pvgen2) + (load1 - pvgen1 - batt1);
        }
        batt1 = 0;
      } else if (load2 < batt2 + pvgen2 && load1 > batt1 + pvgen1 && batt2 + pvgen2 - load2 - (load1 - (batt1 + pvgen1)) < 0) {
        simulationOutput += 'It is Case4: M2 surplus M1 Deficit but M2 surplus is not enough, G is needed\n';
        simulationOutput += 'Battery1, pvgen1 will completely get diminished, and there is a need for energy taken from M2\n';
        simulationOutput += 'M2 surplus energy is not enough, and energy from Generation is needed\n';
        simulationOutput += 'Both batteries get discharged completely\n';
        batt1 = 0;
        batt2 = 0;
      } else if (load1 > batt1 + pvgen1 && load2 > batt2 + pvgen2) {
        simulationOutput += 'It is Case5: Both are deficit\n';
        simulationOutput += 'Both batteries get discharged completely, and generation station is used for power supply to load\n';
        batt1 = 0;
        batt2 = 0;
      } else if (load1 <= batt1 + pvgen1 && load2 <= batt2 + pvgen2) {
        simulationOutput += 'It is Case6: both are surplus\n';
        simulationOutput += 'Here both are surplus so no energy transfer between M1 and M2\n';

        if (pvgen1 >= load1) {
          simulationOutput += 'pvgen1 alone is sufficient to diminish load demand, so no battery discharge\n';

          if (batt1 < 100) {
            simulationOutput += 'excess energy produced from pvgen1 is used to charge battery1\n';

            if (pvgen1 - load1 >= 100 - batt1) {
              simulationOutput += 'battery1 is fully charged\n';
              batt1 = 100;
            } else {
              simulationOutput += 'battery1 is charged with excess energy\n';
              batt1 += pvgen1 - load1;
            }
          }
        } else {
          simulationOutput += 'battery1 is used to satisfy load1\n';
          batt1 -= load1 - pvgen1;
        }

        if (pvgen2 >= load2) {
          simulationOutput += 'pvgen2 alone is sufficient to diminish load demand, so no battery discharge\n';

          if (batt2 < 100) {
            simulationOutput += 'excess energy produced from pvgen2 is used to charge battery2\n';

            if (pvgen2 - load2 >= 100 - batt2) {
              simulationOutput += 'battery2 is fully charged\n';
              batt2 = 100;
            } else {
              simulationOutput += 'battery2 is charged with excess energy\n';
              batt2 += pvgen2 - load2;
            }
          }
        } else {
          simulationOutput += 'battery2 is used to satisfy load2\n';
          batt2 -= load2 - pvgen2;
        }
      } else {
        simulationOutput += 'No case exists\n';
      }

      simulationOutput += `Final battery1 value: ${batt1}\n`;
      simulationOutput += `Final battery2 value: ${batt2}\n`;
      simulationOutput += '-------------------------------------------------------------------------------------------------------------------\n';

      setOutput(simulationOutput);
    }

    setSimulationStarted(false); // Reset the simulation status
  };

  const refreshSimulation = () => {
    setTableData([]);
    setOutput('');
    setSimulationStarted(false);
  };

  return (
    <div style={{ textAlign: 'center', backgroundColor: '#90e0ef', color: 'black', padding: '20px' }}>
      <h2 style={{ fontSize: '40px', marginBottom: '25px' }}>Two Microgrids Simulation</h2>
      <button
        onClick={startSimulation}
        style={{
          backgroundColor: simulationStarted ? 'green' : 'initial',
          color: 'black',
          padding: '10px',
          fontSize: '16px',
          marginRight: '10px'
        }}
      >
        {simulationStarted ? 'Simulation Started' : 'Start Simulation'}
      </button>
      <button
        onClick={refreshSimulation}
        style={{ backgroundColor: 'initial', color: 'black', padding: '10px', fontSize: '16px' }}
      >
        Refresh
      </button>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginTop: '20px',
          marginBottom: '20px',
        }}
      >
        <thead>
          <tr style={{ borderBottom: '2px solid black' }}>
            <th style={{ padding: '10px' }}>Hour</th>
            <th style={{ padding: '10px' }}>PVGen1</th>
            <th style={{ padding: '10px' }}>PVGen2</th>
            <th style={{ padding: '10px' }}>Load1</th>
            <th style={{ padding: '10px' }}>Load2</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index} style={{ borderBottom: '1px solid black' }}>
              <td style={{ padding: '10px' }}>{row.time}</td>
              <td style={{ padding: '10px' }}>{row.pvgen1}</td>
              <td style={{ padding: '10px' }}>{row.pvgen2}</td>
              <td style={{ padding: '10px' }}>{row.load1}</td>
              <td style={{ padding: '10px' }}>{row.load2}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <pre style={{ whiteSpace: 'pre-wrap' }}>{output}</pre>
    </div>
  );
};

export default Simulation;
